export const auth = {
  HEB: {
    authHeader: "התחברו עם",
    google: {
      login: "התחברו עם גוגל",
      signup: "הרשמה עם גוגל",
    },
    apple: {
      login: "התחברות עם אפל",
      signup: "הרשמה עם אפל",
    },
    authSecondHeader: {
      login: "או המשיכו עם",
      signup: "או הרשמו עם",
    },
    noAccount: "אין לכם חשבון? הירשמו עכשיו",
    haveAccount: "יש לכם כבר חשבון? התחברו עכשיו",
    return: "חזרה",
    forgotPassword: "שכחתם את הסיסמה?",
    login: "התחברות",
    signup: "הרשמה",
    logout: "התנתקות",
    codeNotReceived: "עדין לא קיבלתם קוד? ליחצו כאן",
    changePassword: "שינוי סיסמה",
    send: "שליחה",
    email: "אימייל",
    password: "סיסמה",
    emailError: "יש להשתמש באימייל בפורמט תקין",
    // The reason passwordValidation is additional to passwordError is because moneytor's team demand is to give the password different behavior than the email.
    passwordError: "סיסמה לא תקינה",
    passwordValidation: "הסיסמא חייבת להכיל 8 תווים הכוללים אות גדולה, אות קטנה, מספר וסימן מיוחד.",
    signupMessage:
      "אם האימייל שהכנסתם תקין ואינו תפוס במערכת, הינכם אמורים לקבל מייל לאישור בדקות הקרובות",
    sendResetEmail: "הינכם אמורים לקבל מייל לאיפוס סיסמה בדקות הקרובות",
    invalidCredentials: "אימייל או סיסמה שגויים",
    emailNotConfirmed:
      "אימייל לא מאושר, נא אשרו את ההרשמה למערכת דרך כניסה ללינק במייל שנשלח אליכם",
    genericError: "אופס.. משהו השתבש, נסו שנית",
    registrationConfirmation: "אישור הרשמה",
    understood: "הבנתי",
    biometric: {
      login: "התחברות ביומטרית",
      error: "האימות הביומטרי נכשל",
    },
  },
  ENG: {
    authHeader: "Sign in with",
    google: {
      login: "Sign in with Google",
      signup: "Sign up with Google",
    },
    apple: {
      login: "Sign in with Apple",
      signup: "Sign up with Apple",
    },
    authSecondHeader: {
      login: "or continue with",
      signup: "or sign up with",
    },
    noAccount: "Don't have an account? Sign up now",
    haveAccount: "Already have an account? Sign in now",
    return: "Back",
    forgotPassword: "Forgot your password?",
    login: "Sign in",
    signup: "Sign up",
    logout: "Sign out",
    codeNotReceived: "Didn't receive a code? Click here",
    changePassword: "Change password",
    send: "Send",
    email: "Email",
    password: "Password",
    emailError: "Please use a valid email format",
    passwordError: "Invalid password",
    passwordValidation: "Password must contain 8 characters including an uppercase letter, a lowercase letter, a number and a special character.",
    signupMessage:
      "If the email you entered is valid and not already in use, you should receive a confirmation email shortly",
    sendResetEmail: "You should receive a password reset email shortly",
    invalidCredentials: "Invalid email or password",
    emailNotConfirmed:
      "Email not confirmed. Please confirm your registration via the link sent to your email",
    genericError: "Oops... something went wrong, please try again",
    registrationConfirmation: "Registration Confirmation",
    understood: "Got it",
    biometric: {
      login: "Sign in with biometric",
      error: "Biometric login failed",
    },
  },
  RUS: {
    authHeader: "Войти через",
    google: {
      login: "Войти через Google",
      signup: "Зарегистрироваться через Google",
    },
    apple: {
      login: "Войти через Apple",
      signup: "Зарегистрироваться через Apple",
    },
    authSecondHeader: {
      login: "или продолжить с",
      signup: "или зарегистрироваться с",
    },
    noAccount: "Нет аккаунта? Зарегистрируйтесь сейчас",
    haveAccount: "Уже есть аккаунт? Войдите сейчас",
    return: "Назад",
    forgotPassword: "Забыли пароль?",
    login: "Вход",
    signup: "Регистрация",
    logout: "Выйти",
    codeNotReceived: "Не получили код? Нажмите здесь",
    changePassword: "Изменить пароль",
    send: "Отправить",
    email: "Электронная почта",
    password: "Пароль",
    emailError: "Пожалуйста, используйте корректный формат электронной почты",
    passwordError: "Неверный пароль",
    passwordValidation: "Пароль должен содержать 8 символов, включая заглавную букву, строчную букву, цифру и специальный символ.",
    signupMessage:
      "Если введённый вами email корректен и не используется в системе, вы должны получить письмо с подтверждением в ближайшее время",
    sendResetEmail: "Вы должны получить письмо для сброса пароля в ближайшее время",
    invalidCredentials: "Неверный email или пароль",
    emailNotConfirmed:
      "Email не подтверждён. Пожалуйста, подтвердите регистрацию по ссылке, отправленной на ваш email",
    genericError: "Ой... что-то пошло не так, попробуйте ещё раз",
    registrationConfirmation: "Подтверждение регистрации",
    understood: "Понятно",
    biometric: {
      login: "Биометрический вход",
      error: "Биометрическая аутентификация не удалась",
    },
  },
};
